import { gql } from "@grandvisionhq/graphql";
const StoresFilter = gql`
  fragment StoresFilter on StoresFilter {
    name
    options {
      name
      count
    }
  }
`;
export {
  StoresFilter as default
};
//# sourceMappingURL=stores-filter.js.map
